// --- Step 4 : Initial Values ---
export const chemoProtocolInitialValues = {
    chemo_regimen_details: "",
    treatment_intent: "",
    vascular_access: "",
    known_drug_allergies: "",
    significant_adverse_reactions_reported: "",
    chemo_dosage: [
        { chemo_administered_date: null, chemo_dosage: "" }
    ]
};


// --- Step 4 : Map GET Response to Formik values ---
export const mapChemoProtocolResponse = (data) => {
    if (!data) return chemoProtocolInitialValues;

    const treatments = Array.isArray(data?.treatments)
        ? [...data?.treatments]
            .sort((a, b) => a?.chemo_treatment_id - b?.chemo_treatment_id)
            .map((t) => ({
                chemo_administered_date: t?.chemo_administered_date?.slice(0, 10) || null,
                chemo_dosage: t?.chemo_dosage || "",
            }))
        : [{ chemo_administered_date: null, chemo_dosage: "" }];

    return {
        chemo_regimen_details: data?.chemo_regimen_details || "",
        treatment_intent: data?.treatment_intent || "",
        vascular_access: data?.vascular_access || "",
        known_drug_allergies: data?.known_drug_allergies || "",
        significant_adverse_reactions_reported:
            data?.significant_adverse_reactions_reported || "",
        chemo_dosage: treatments
    };
};
